import React, {Component} from 'react';
import Score from './score';
import LevelsGrid from './levelsgrid';
import Levels from '../../src/data';
import { connect } from "react-redux";
import { setGameOptions } from "../actions"
import Tooltip from "./tooltip";
import Email from "./email";

class Menu extends Component {
	componentWillUnmount(){
		this.props.setGameOptions({ tutorial_seen: true });
	}
	render() {
		const allLevelsUnlocked = this.props.unlockedLevel === 54;
		const levels = Levels.slice(0, 54);
	    return (
			<div>
				<Score levels={levels} unlockedLevel={this.props.unlockedLevel} />
				<div className="clear" />
				{ this.props.tutorialSeen ? ''  : ( <Tooltip /> ) }
				{ allLevelsUnlocked ? ( <Email /> ) : '' }
				<LevelsGrid allLevelsUnlocked={allLevelsUnlocked} unlockedLevel={this.props.unlockedLevel} levels={levels} />
			</div>
		);
	}
}
const mapStateToProps = ({ GameOptions }) => {
  return {
		unlockedLevel: GameOptions.unlocked_level,
		tutorialSeen: GameOptions.tutorial_seen
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setGameOptions: GameOptions => {
      dispatch(setGameOptions(GameOptions));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/menu.js